class FabricPurchase extends HTMLElement{
    constructor(){
        super();

        this.selectedImages  = [];
        this.selectedFabrics = [];

        this.fabricImages           = document.querySelectorAll('.item-image');
        this.fabricsSelectedItems   = document.querySelector('.fabric-selected');

        this.lineItemProperties     = document.querySelector('[name="properties[Fabrics]"]');
    }

    connectedCallback(){

        const self = this;

        self.fabricImages.forEach(fabricEl => {
            fabricEl.addEventListener('click', function () {
                let fabricName = this.dataset.fabric;
                self.handleFabricSelection(fabricName);
            });
        });

        self.fabricsSelectedItems.addEventListener('click', function (event) {
            if (event.target.closest('.image-fabric')) {
                let fabricName = event.target.closest('.image-fabric').dataset.fabric;
                self.handleFabricRemoval(fabricName);
            }
        });
    }

    handleFabricSelection(fabricName) {
        if (this.selectedFabrics.includes(fabricName)) {
            this.handleFabricRemoval(fabricName);
        } else {
            if (this.selectedFabrics.length < 5) {
                this.selectedFabrics.push(fabricName);
            } else {
                this.selectedFabrics.shift();
                this.selectedFabrics.push(fabricName);
            }
            this.updateSelectedFabrics();
        }
    }

    handleFabricRemoval(fabricName) {
        this.selectedFabrics = this.selectedFabrics.filter(fabric => fabric !== fabricName);
        this.updateSelectedFabrics();
    }

    updateSelectedFabrics() {

        [...this.fabricImages].map( x => x.classList.remove('selected'));
        var fabricSelectedElements = this.fabricsSelectedItems.querySelectorAll('.fabric');

        this.lineItemProperties.value = this.selectedFabrics.length ? this.selectedFabrics.toString() : '';
        fabricSelectedElements.forEach( (fabricEl, index) => {
            let fabricName = this.selectedFabrics[index] || '';
                fabricEl.innerHTML = '';
            let fabricImage = Array.from(this.fabricImages).find(element => element.dataset.fabric === fabricName);
            if (typeof fabricImage === 'undefined') return;
                fabricImage.classList.add('selected');
                let fabricImageClone = fabricImage?.cloneNode(true);

                fabricEl.innerHTML = fabricImage ? fabricImageClone.outerHTML : '';

        });

        if( this.selectedFabrics.length > 0  ) {
            document.querySelector('button[name="add"]').disabled = false;
            if( this.selectedFabrics.length == 5  ) {
                [...this.fabricImages].forEach( (elm) => {
                    if(!elm.classList.contains('selected')){
                        elm.classList.add('disabled')
                    }
                })
            }else{
                [...this.fabricImages].map( x => x.classList.remove('disabled'));
            }
        }else{
          document.querySelector('button[name="add"]').disabled = true;  
        }
    }
}
customElements.define('fabric-purchase', FabricPurchase);

